"use client";

import React, { useRef } from "react";
import MicrophoneCard from "./microphone-card";
import classNames from "classnames";
import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { Microphone } from "@/types";
import { useGSAP } from "@gsap/react";

interface MicListProps {
  microphones: Microphone[];
  listViewStyle: string;
  fullWidth?: boolean;
  onRegisterMicrophone?: (id: string, letter: string, element: HTMLElement) => void;
}
gsap.registerPlugin(Flip);
gsap.registerPlugin(useGSAP);

const MicrophoneList = ({ microphones, listViewStyle, fullWidth = false, onRegisterMicrophone }: MicListProps) => {
  const myList = useRef<HTMLUListElement | null>(null);
  // const q = gsap.utils.selector(myList);

  const micElements = microphones.map((mic) => {
    const firstLetter = `${mic.manufacturer} ${mic.model}`.charAt(0).toUpperCase();
    return (
      <MicrophoneCard
        microphone={mic}
        listOrCard={listViewStyle}
        key={mic.slug}
        id={`mic-${firstLetter}-${mic.slug}`}
        onRegister={onRegisterMicrophone}
        firstLetter={firstLetter}
      />
    );
  });

  // const [layout] = useState({
  //   state: Flip.getState(q(".mic-item")),
  //   items: micElements,
  // });
  // const [ctx] = useState(() => gsap.context(() => {}));
  // const removeItems = useCallback(
  //   (exitingItems) => {
  //     if (!exitingItems.length) return;

  //     setLayout((prev) => ({
  //       state: Flip.getState(q(".mic-item")),
  //       items: prev.items.filter((item) => !exitingItems.includes(item)),
  //     }));
  //   },
  //   [q]
  // );

  // useEffect(() => {
  //   return () => ctx.revert();
  // }, []);

  // useLayoutEffect(() => {
  //   if (!layout.state) return;

  //   // get the items that are exiting in this batch
  //   const exiting = layout.items.filter((item) => item.status === "exiting");
  //   ctx.add(() => {
  //     // Flip.from returns a timeline
  //     const timeline = Flip.from(layout.state, {
  //       absolute: true,
  //       ease: "power1.inOut",
  //       targets: q(".mic-item"),
  //       scale: true,
  //       simple: true,
  //       onEnter: (elements) => {
  //         console.log("elements = ", elements);
  //         return gsap.fromTo(
  //           elements,
  //           {
  //             opacity: 0,
  //             scale: 0,
  //           },
  //           {
  //             opacity: 1,
  //             scale: 1,
  //             delay: 0.5,
  //             duration: 0.3,
  //           }
  //         );
  //       },
  //       onLeave: (elements) => {
  //         console.log("leave elements = ", elements);
  //         return gsap.fromTo(
  //           elements,
  //           {
  //             opacity: 1,
  //             scale: 1,
  //           },
  //           {
  //             opacity: 0,
  //             scale: 0,
  //             duration: 0.5,
  //           }
  //         );
  //       },
  //       onComplete() {
  //         // works around a Safari rendering bug (unrelated to GSAP). Things reflow narrower otherwise.
  //         // let boxes = document.querySelector(".boxes"),
  //         //   lastChild = boxes.lastChild;
  //         // boxes.appendChild(lastChild);
  //       },
  //     });

  //     // remove the exiting items from the DOM after the animation is done
  //     timeline.add(() => removeItems(exiting));
  //   });
  // }, [ctx, layout, q, removeItems]);

  const styleString = classNames({
    "grid": true,
    "grid-cols-1": listViewStyle === "list" || !fullWidth,
    "gap-3 md:gap-5": listViewStyle !== "list",
    // Responsive grid for full width: 1 mobile, 2 tablet/desktop, 3 very wide screens
    "md:grid-cols-2 xl:grid-cols-3": fullWidth && listViewStyle !== "list",
    // Original layout when not full width
    "md:grid-cols-2": !fullWidth && listViewStyle !== "list",
  });

  return (
    <ul className={styleString} ref={myList}>
      {micElements}
    </ul>
  );
};

export default MicrophoneList;
